export default __webpack_public_path__ + "static/media/README.6c9285a1.md";